export type IconConfig = {
    badgeBg: string      // background color of the circular badge
    stroke: string       // SVG stroke color
    paths: JSX.Element   // SVG child elements (rect, line, path, circle, etc.)
}

export const COLUMN_ICON_MAP: Record<string, IconConfig> = {
    Date: {
        badgeBg: '#e8f5e9',
        stroke: '#003B73',
        paths: (
            <>
                <rect x='3' y='4' width='18' height='18' rx='2' ry='2' />
                <line x1='16' y1='2' x2='16' y2='6' />
                <line x1='8' y1='2' x2='8' y2='6' />
                <line x1='3' y1='10' x2='21' y2='10' />
            </>
        ),
    },
    'Request Id': {
        badgeBg: '#e3f2fd',
        stroke: '#1565c0',
        paths: (
            <>
                <path d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z' />
                <polyline points='14 2 14 8 20 8' />
                <line x1='16' y1='13' x2='8' y2='13' />
                <line x1='16' y1='17' x2='8' y2='17' />
                <polyline points='10 9 9 9 8 9' />
            </>
        ),
    },
    Recycler: {
        badgeBg: '#f3e5f5',
        stroke: '#34A853',
        paths: (
            <>
                <path d="M7.86 2.34 6.05 5.5a1 1 0 0 0 .87 1.5h3.17" />
                <path d="m7.86 2.34 3.46 2" />
                <path d="m21.95 10.5-1.82-3.16a1 1 0 0 0-1.73 0l-1.59 2.74" />
                <path d="m21.95 10.5-3.46 2" />
                <path d="m16.14 21.66 1.82-3.16a1 1 0 0 0-.87-1.5h-3.17" />
                <path d="m16.14 21.66-3.46-2" />
                <path d="M4.5 13H2" />
                <path d="M22 13h-2.5" />
                <path d="M12 22v-2.5" />
            </>
        ),
    },
    category: {
        badgeBg: '#fff8e1',
        stroke: '#f57f17',
        paths: (
            <>
                <line x1='8' y1='6' x2='21' y2='6' />
                <line x1='8' y1='12' x2='21' y2='12' />
                <line x1='8' y1='18' x2='21' y2='18' />
                <line x1='3' y1='6' x2='3.01' y2='6' />
                <line x1='3' y1='12' x2='3.01' y2='12' />
                <line x1='3' y1='18' x2='3.01' y2='18' />
            </>
        ),
    },
    item: {
        badgeBg: '#fce4ec',
        stroke: '#c62828',
        paths: (
            <>
                <polyline points='22 12 16 12 14 15 10 15 8 12 2 12' />
                <path d='M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z' />
            </>
        ),
    },
    'qty (Kg)': {
        badgeBg: '#e0f7fa',
        stroke: '#00695c',
        paths: (
            <>
                <line x1='12' y1='20' x2='12' y2='10' />
                <line x1='18' y1='20' x2='18' y2='4' />
                <line x1='6' y1='20' x2='6' y2='16' />
            </>
        ),
    },
    Price: {
        badgeBg: '#e8f5e9',
        stroke: '#2e7d32',
        paths: (
            <>
                <line x1='12' y1='1' x2='12' y2='23' />
                <path d='M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6' />
            </>
        ),
    },
    delivery: {
        badgeBg: '#fff3e0',
        stroke: '#e65100',
        paths: (
            <>
                <rect x='1' y='3' width='15' height='13' />
                <polygon points='16 8 20 8 23 11 23 16 16 16 16 8' />
                <circle cx='5.5' cy='18.5' r='2.5' />
                <circle cx='18.5' cy='18.5' r='2.5' />
            </>
        ),
    },
    details: {
        badgeBg: '#e8eaf6',
        stroke: '#283593',
        paths: (
            <>
                <circle cx='12' cy='12' r='10' />
                <line x1='12' y1='8' x2='12' y2='12' />
                <line x1='12' y1='16' x2='12.01' y2='16' />
            </>
        ),
    },
    Actions: {
        badgeBg: '#e8eaf6',
        stroke: '#283593',
        paths: (

            <>
                <circle cx="12" cy="12" r="1" />
                <circle cx="19" cy="12" r="1" />
                <circle cx="5" cy="12" r="1" />
            </>

        ),
    },
    'S.N': {
        badgeBg: '#e8eaf6',
        stroke: '#283593',
        paths: (
            <>
                <line x1="10" y1="6" x2="21" y2="6" />
                <line x1="10" y1="12" x2="21" y2="12" />
                <line x1="10" y1="18" x2="21" y2="18" />
                <path d="M4 6h1v4" />
                <path d="M4 10h2" />
                <path d="M4 14c0-1 1-2 2-2s2 1 2 2-1 2-2 2-2 1-2 2h4" />
            </>

        ),
    },
    'Business name': {
        badgeBg: '#e8f5e9',
        stroke: '#003B73',
        paths: (
            <>
                <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
                <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
            </>
        ),
    },
    'Contact': {
        badgeBg: '#e3f2fd',
        stroke: '#1565c0',
        paths: (
            <>
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </>
        ),
    },
    'Address': {
        badgeBg: '#f3e5f5',
        stroke: '#8e24aa',
        paths: (
            <>
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
            </>
        ),
    },
    'KYC': {
        badgeBg: '#fff8e1',
        stroke: '#f57f17',
        paths: (
            <>
                <rect x="2" y="5" width="20" height="14" rx="2" ry="2" />
                <path d="M7 15h0" />
                <path d="M11 15h6" />
                <path d="M11 11h6" />
                <circle cx="7" cy="11" r="2" />
            </>
        ),
    },
    'bank details': {
        badgeBg: '#e0f7fa',
        stroke: '#00695c',
        paths: (
            <>
                <rect x="3" y="20" width="18" height="2" />
                <rect x="5" y="11" width="3" height="7" />
                <rect x="11" y="11" width="2" height="7" />
                <rect x="16" y="11" width="3" height="7" />
                <polygon points="12 4 3 9 21 9" />
            </>
        ),
    },
    'Status': {
        badgeBg: '#e8f5e9',
        stroke: '#2e7d32',
        paths: (
            <>
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
            </>
        ),
    },
    'Facility Name': {
        badgeBg: '#fbe9e7',
        stroke: '#d84315',
        paths: (
            <>
                <path d="M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" />
                <path d="M17 18h1" />
                <path d="M13 18h1" />
                <path d="M9 18h1" />
            </>
        ),
    },
    'City': {
        badgeBg: '#e8eaf6',
        stroke: '#3f51b5',
        paths: (
            <>
                <path d="M10 9h4" />
                <path d="M10 13h4" />
                <path d="M10 17h4" />
                <path d="M4 13h2" />
                <path d="M4 17h2" />
                <path d="M3 21h18" />
                <path d="M20 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2H8a2 2 0 0 0-2 2v2H4a2 2 0 0 0-2 2v10" />
            </>
        ),
    },
    'Collected': {
        badgeBg: '#e0f2f1',
        stroke: '#00796b',
        paths: (
            <>
                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
                <line x1="12" y1="22.08" x2="12" y2="12" />
            </>
        ),
    },
    'Processed': {
        badgeBg: '#fff3e0',
        stroke: '#ef6c00',
        paths: (
            <>
                <path d="M12 22v-4" />
                <path d="M12 6V2" />
                <path d="M22 12h-4" />
                <path d="M6 12H2" />
                <path d="m19 19-2.8-2.8" />
                <path d="m7.8 7.8-2.8-2.8" />
                <path d="m19 5-2.8 2.8" />
                <path d="m7.8 16.2-2.8 2.8" />
                <circle cx="12" cy="12" r="4" />
            </>
        ),
    },
    'Supplied': {
        badgeBg: '#e8f5e9',
        stroke: '#2e7d32',
        paths: (
            <>
                <rect x="1" y="3" width="15" height="13" />
                <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
                <circle cx="5.5" cy="18.5" r="2.5" />
                <circle cx="18.5" cy="18.5" r="2.5" />
                <line x1="8" y1="8" x2="8" y2="8.01" />
            </>
        ),
    },
    'Stock': {
        badgeBg: '#fce4ec',
        stroke: '#c2185b',
        paths: (
            <>
                <ellipse cx="12" cy="5" rx="9" ry="3" />
                <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" />
                <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
            </>
        ),
    },
    'Name': {
        badgeBg: '#e3f2fd',
        stroke: '#1565c0',
        paths: (
            <>
                <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
            </>
        ),
    },
    'Mobile Number': {
        badgeBg: '#e8eaf6',
        stroke: '#3f51b5',
        paths: (
            <>
                <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
                <line x1="12" y1="18" x2="12.01" y2="18" />
            </>
        ),
    },
    'Email Address': {
        badgeBg: '#fbe9e7',
        stroke: '#d84315',
        paths: (
            <>
                <rect x="2" y="4" width="20" height="16" rx="2" />
                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
            </>
        ),
    },
    'Region': {
        badgeBg: '#e0f2f1',
        stroke: '#00796b',
        paths: (
            <>
                <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21" />
                <line x1="9" y1="3" x2="9" y2="18" />
                <line x1="15" y1="6" x2="15" y2="21" />
            </>
        ),
    },
    'Supply Partner': {
        badgeBg: '#fff8e1',
        stroke: '#f57f17',
        paths: (
            <>
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </>
        ),
    },
    'Birthday': {
        badgeBg: '#fce4ec',
        stroke: '#c2185b',
        paths: (
            <>
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
            </>
        ),
    },
    'Gender': {
        badgeBg: '#f3e5f5',
        stroke: '#8e24aa',
        paths: (
            <>
                <circle cx="12" cy="7" r="4" />
                <path d="M5 22v-5l2-2" />
                <path d="M19 22v-5l-2-2" />
                <path d="M7 15h10" />
            </>
        ),
    },
    'Staff': {
        badgeBg: '#e8f5e9',
        stroke: '#2e7d32',
        paths: (
            <>
                <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
                <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
                <path d="M9 14h6" />
                <path d="M9 11h6" />
            </>
        ),
    },
    'business name': {
        badgeBg: '#e8f5e9',
        stroke: '#003B73',
        paths: (
            <>
                <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
                <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
            </>
        ),
    },
    'Field Executive': {
        badgeBg: '#e0f7fa',
        stroke: '#006064',
        paths: (
            <>
                <circle cx="12" cy="7" r="4" />
                <path d="M5 22v-5l2-2" />
                <path d="M19 22v-5l-2-2" />
                <path d="M12 11v6" />
                <path d="M12 11H7" />
                <path d="M12 11h5" />
            </>
        ),
    },
    'SSM': {
        badgeBg: '#fff3e0',
        stroke: '#ef6c00',
        paths: (
            <>
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="16" y1="13" x2="8" y2="13" />
                <line x1="16" y1="17" x2="8" y2="17" />
                <polyline points="10 9 9 9 8 9" />
            </>
        ),
    },
    'Bank': {
        badgeBg: '#e8eaf6',
        stroke: '#283593',
        paths: (
            <>
                <rect x="3" y="20" width="18" height="2" />
                <rect x="5" y="11" width="3" height="7" />
                <rect x="11" y="11" width="2" height="7" />
                <rect x="16" y="11" width="3" height="7" />
                <polygon points="12 4 3 9 21 9" />
            </>
        ),
    },
    'Account No': {
        badgeBg: '#fce4ec',
        stroke: '#880e4f',
        paths: (
            <>
                <line x1="4" y1="9" x2="20" y2="9" />
                <line x1="4" y1="15" x2="20" y2="15" />
                <line x1="10" y1="3" x2="8" y2="21" />
                <line x1="16" y1="3" x2="14" y2="21" />
            </>
        ),
    },
    'Order Id': {
        badgeBg: '#fbe9e7',
        stroke: '#d84315',
        paths: (
            <>
                <line x1="4" y1="9" x2="20" y2="9" />
                <line x1="4" y1="15" x2="20" y2="15" />
                <line x1="10" y1="3" x2="8" y2="21" />
                <line x1="16" y1="3" x2="14" y2="21" />
            </>
        ),
    },
    'Aggregator': {
        badgeBg: '#e8eaf6',
        stroke: '#3f51b5',
        paths: (
            <>
                <rect x="2" y="2" width="20" height="8" rx="2" ry="2" />
                <rect x="2" y="14" width="20" height="8" rx="2" ry="2" />
                <line x1="6" y1="6" x2="6.01" y2="6" />
                <line x1="6" y1="18" x2="6.01" y2="18" />
            </>
        ),
    },
    'Plastic': {
        badgeBg: '#e0f2f1',
        stroke: '#00796b',
        paths: (
            <>
                <path d="M15.3 8.8l-3.3 5.8-3.2-5.8" />
                <path d="M8.7 15l3.3-5.8 3.2 5.8" />
                <path d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z" />
            </>
        ),
    },
    'Quantity': {
        badgeBg: '#fff3e0',
        stroke: '#ef6c00',
        paths: (
            <>
                <line x1="8" y1="6" x2="21" y2="6" />
                <line x1="8" y1="12" x2="21" y2="12" />
                <line x1="8" y1="18" x2="21" y2="18" />
                <line x1="3" y1="6" x2="3.01" y2="6" />
                <line x1="3" y1="12" x2="3.01" y2="12" />
                <line x1="3" y1="18" x2="3.01" y2="18" />
            </>
        ),
    },
    'Payment Mode': {
        badgeBg: '#f3e5f5',
        stroke: '#8e24aa',
        paths: (
            <>
                <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
                <line x1="1" y1="10" x2="23" y2="10" />
            </>
        ),
    },
    'Waste picker': {
        badgeBg: '#e8f5e9',
        stroke: '#2e7d32',
        paths: (
            <>
                <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
                <path d="M16 11l4-4" />
            </>
        ),
    },
    'Amount': {
        badgeBg: '#fff8e1',
        stroke: '#f57f17',
        paths: (
            <>
                <line x1="12" y1="1" x2="12" y2="23" />
                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
            </>
        ),
    },
    'Mode': {
        badgeBg: '#e3f2fd',
        stroke: '#1565c0',
        paths: (
            <>
                <rect x="2" y="8" width="20" height="8" rx="4" ry="4" />
                <circle cx="18" cy="12" r="2" />
            </>
        ),
    },
    'Supply partner': {
        badgeBg: '#fff8e1',
        stroke: '#f57f17',
        paths: (
            <>
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </>
        ),
    },
    'Material': {
        badgeBg: '#e8eaf6',
        stroke: '#3f51b5',
        paths: (
            <>
                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
                <line x1="12" y1="22.08" x2="12" y2="12" />
            </>
        ),
    },
    'Transport': {
        badgeBg: '#fbe9e7',
        stroke: '#d84315',
        paths: (
            <>
                <rect x="1" y="3" width="15" height="13" />
                <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
                <circle cx="5.5" cy="18.5" r="2.5" />
                <circle cx="18.5" cy="18.5" r="2.5" />
            </>
        ),
    },
    'reconciliation': {
        badgeBg: '#e0f7fa',
        stroke: '#006064',
        paths: (
            <>
                <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
                <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
                <path d="M9 14h6" />
                <path d="M9 18h6" />
                <path d="M9 10h.01" />
            </>
        ),
    },
    'certificate_view': {
        badgeBg: '#fce4ec',
        stroke: '#c2185b',
        paths: (
            <>
                <circle cx="12" cy="8" r="7" />
                <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88" />
            </>
        ),
    },
    'role': {
        badgeBg: '#e0f7fa',
        stroke: '#006064',
        paths: (
            <>
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
                <path d="m9 12 2 2 4-4" />
            </>
        ),
    },
    'Email': {
        badgeBg: '#fbe9e7',
        stroke: '#d84315',
        paths: (
            <>
                <rect x="2" y="4" width="20" height="16" rx="2" />
                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
            </>
        ),
    },
    'City, Province': {
        badgeBg: '#e8eaf6',
        stroke: '#3f51b5',
        paths: (
            <>
                <path d="M10 9h4" />
                <path d="M10 13h4" />
                <path d="M10 17h4" />
                <path d="M4 13h2" />
                <path d="M4 17h2" />
                <path d="M3 21h18" />
                <path d="M20 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2H8a2 2 0 0 0-2 2v2H4a2 2 0 0 0-2 2v10" />
            </>
        ),
    },
    'Geo Location': {
        badgeBg: '#e0f2f1',
        stroke: '#00796b',
        paths: (
            <>
                <polygon points="3 11 22 2 13 21 11 13 3 11" />
            </>
        ),
    },
    'joining Date': {
        badgeBg: '#f3e5f5',
        stroke: '#8e24aa',
        paths: (
            <>
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
                <path d="M9 16h6" />
                <path d="M12 13v6" />
            </>
        ),
    },
    'A/C Holder': {
        badgeBg: '#fff8e1',
        stroke: '#f57f17',
        paths: (
            <>
                <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
                <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
                <circle cx="9" cy="13" r="2" />
                <path d="M9 17v-1a2 2 0 0 1 4 0" />
            </>
        ),
    },
    'Street': {
        badgeBg: '#fbe9e7',
        stroke: '#d84315',
        paths: (
            <>
                <path d="M4 22L12 2l8 20" />
                <path d="M12 12v2" />
                <path d="M12 18v2" />
                <path d="M12 6v2" />
            </>
        ),
    },
    'Zip Code': {
        badgeBg: '#e8eaf6',
        stroke: '#3f51b5',
        paths: (
            <>
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
            </>
        ),
    },
    'Bank Name': {
        badgeBg: '#e8eaf6',
        stroke: '#283593',
        paths: (
            <>
                <rect x="3" y="20" width="18" height="2" />
                <rect x="5" y="11" width="3" height="7" />
                <rect x="11" y="11" width="2" height="7" />
                <rect x="16" y="11" width="3" height="7" />
                <polygon points="12 4 3 9 21 9" />
            </>
        ),
    },
    'Ac Number': {
        badgeBg: '#fce4ec',
        stroke: '#880e4f',
        paths: (
            <>
                <line x1="4" y1="9" x2="20" y2="9" />
                <line x1="4" y1="15" x2="20" y2="15" />
                <line x1="10" y1="3" x2="8" y2="21" />
                <line x1="16" y1="3" x2="14" y2="21" />
            </>
        ),
    },
    'ID PIC': {
        badgeBg: '#e0f7fa',
        stroke: '#006064',
        paths: (
            <>
                <rect x="3" y="4" width="18" height="16" rx="2" ry="2" />
                <circle cx="9" cy="10" r="2" />
                <path d="M15 8h2" />
                <path d="M15 12h2" />
                <path d="M7 16h5" />
            </>
        ),
    },
    'Profile Pic': {
        badgeBg: '#fff3e0',
        stroke: '#ef6c00',
        paths: (
            <>
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                <circle cx="8.5" cy="8.5" r="1.5" />
                <polyline points="21 15 16 10 5 21" />
            </>
        ),
    },
    'Total Payment': {
        badgeBg: '#e8f5e9',
        stroke: '#2e7d32',
        paths: (
            <>
                <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4" />
                <path d="M3 5v14a2 2 0 0 0 2 2h16v-5" />
                <path d="M18 12a2 2 0 0 0 0 4h4v-4Z" />
            </>
        ),
    },
    'Joining Date': {
        badgeBg: '#f3e5f5',
        stroke: '#8e24aa',
        paths: (
            <>
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
                <path d="M9 16h6" />
                <path d="M12 13v6" />
            </>
        ),
    },
    'Current Level': {
        badgeBg: '#fff8e1',
        stroke: '#f57f17',
        paths: (
            <>
                <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
                <polyline points="16 7 22 7 22 13" />
            </>
        ),
    },
    'Points Earned': {
        badgeBg: '#e3f2fd',
        stroke: '#1565c0',
        paths: (
            <>
                <circle cx="8" cy="8" r="6" />
                <path d="M18.09 10.37A6 6 0 1 1 10.34 18" />
                <path d="M7 6h2" />
                <path d="M8 5v2" />
            </>
        ),
    },
    'Redeemed': {
        badgeBg: '#fce4ec',
        stroke: '#c2185b',
        paths: (
            <>
                <rect x="3" y="8" width="18" height="4" rx="1" />
                <path d="M12 8v13" />
                <path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7" />
                <path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5" />
            </>
        ),
    },
    'Type': {
        badgeBg: '#e0f7fa',
        stroke: '#006064',
        paths: (
            <>
                <rect x="3" y="3" width="7" height="7" rx="1" />
                <rect x="14" y="3" width="7" height="7" rx="1" />
                <rect x="14" y="14" width="7" height="7" rx="1" />
                <rect x="3" y="14" width="7" height="7" rx="1" />
            </>
        ),
    },
    'GST': {
        badgeBg: '#fff3e0',
        stroke: '#ef6c00',
        paths: (
            <>
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <circle cx="10" cy="13" r="1" />
                <circle cx="14" cy="17" r="1" />
                <line x1="14" y1="13" x2="10" y2="17" />
            </>
        ),
    },
    'Product Name': {
        badgeBg: '#e8f5e9',
        stroke: '#2e7d32',
        paths: (
            <>
                <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
                <line x1="7" y1="7" x2="7.01" y2="7" />
            </>
        ),
    },
    'Dpp ID': {
        badgeBg: '#e3f2fd',
        stroke: '#1565c0',
        paths: (
            <>
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                <path d="M7 7h10" />
                <path d="M7 11h10" />
                <path d="M7 15h10" />
            </>
        ),
    },
    'SKU Item': {
        badgeBg: '#fce4ec',
        stroke: '#c2185b',
        paths: (
            <>
                <path d="M3 5v14" />
                <path d="M8 5v14" />
                <path d="M12 5v14" />
                <path d="M17 5v14" />
                <path d="M21 5v14" />
            </>
        ),
    },
    'Dimension': {
        badgeBg: '#e0f2f1',
        stroke: '#00796b',
        paths: (
            <>
                <polyline points="15 3 21 3 21 9" />
                <polyline points="9 21 3 21 3 15" />
                <line x1="21" y1="3" x2="14" y2="10" />
                <line x1="3" y1="21" x2="10" y2="14" />
            </>
        ),
    },
    'Weight': {
        badgeBg: '#fff8e1',
        stroke: '#f57f17',
        paths: (
            <>
                <circle cx="12" cy="5" r="3" />
                <path d="M6.5 8a2 2 0 0 0-1.905 1.46L2.1 18.5A2 2 0 0 0 4 21h16a2 2 0 0 0 1.905-2.54l-2.495-9.04A2 2 0 0 0 17.5 8h-11z" />
            </>
        ),
    },
    'Product Imgae': {
        badgeBg: '#f3e5f5',
        stroke: '#8e24aa',
        paths: (
            <>
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                <circle cx="8.5" cy="8.5" r="1.5" />
                <polyline points="21 15 16 10 5 21" />
            </>
        ),
    },
    'View': {
        badgeBg: '#e8eaf6',
        stroke: '#3f51b5',
        paths: (
            <>
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                <circle cx="12" cy="12" r="3" />
            </>
        ),
    },
    'Seller': {
        badgeBg: '#fff8e1',
        stroke: '#f57f17',
        paths: (
            <>
                <path d="M20 10v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V10" />
                <path d="M9 22V12h6v10" />
                <path d="M2 10l10-7 10 7" />
            </>
        ),
    },
    'Buyer': {
        badgeBg: '#e8f5e9',
        stroke: '#2e7d32',
        paths: (
            <>
                <circle cx="9" cy="21" r="1" />
                <circle cx="20" cy="21" r="1" />
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
            </>
        ),
    },
    'Category': {
        badgeBg: '#fff8e1',
        stroke: '#f57f17',
        paths: (
            <>
                <line x1='8' y1='6' x2='21' y2='6' />
                <line x1='8' y1='12' x2='21' y2='12' />
                <line x1='8' y1='18' x2='21' y2='18' />
                <line x1='3' y1='6' x2='3.01' y2='6' />
                <line x1='3' y1='12' x2='3.01' y2='12' />
                <line x1='3' y1='18' x2='3.01' y2='18' />
            </>
        ),
    },
    'Item': {
        badgeBg: '#fce4ec',
        stroke: '#c62828',
        paths: (
            <>
                <polyline points='22 12 16 12 14 15 10 15 8 12 2 12' />
                <path d='M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z' />
            </>
        ),
    },
    'Qty (Kg)': {
        badgeBg: '#e0f7fa',
        stroke: '#00695c',
        paths: (
            <>
                <line x1='12' y1='20' x2='12' y2='10' />
                <line x1='18' y1='20' x2='18' y2='4' />
                <line x1='6' y1='20' x2='6' y2='16' />
            </>
        ),
    },
    'Details': {
        badgeBg: '#e8eaf6',
        stroke: '#283593',
        paths: (
            <>
                <circle cx='12' cy='12' r='10' />
                <line x1='12' y1='8' x2='12' y2='12' />
                <line x1='12' y1='16' x2='12.01' y2='16' />
            </>
        ),
    },
    'Distance (Km)': {
        badgeBg: '#e0f7fa',
        stroke: '#006064',
        paths: (
            <>
                <circle cx="12" cy="10" r="3" />
                <path d="M12 21.7C17.3 17 20 13 20 10a8 8 0 1 0-16 0c0 3 2.7 7 8 11.7z" />
            </>
        ),
    },
    'Cost (INR)': {
        badgeBg: '#fff8e1',
        stroke: '#f57f17',
        paths: (
            <>
                <rect x="2" y="6" width="20" height="12" rx="2" />
                <circle cx="12" cy="12" r="2" />
                <path d="M6 12h.01M18 12h.01" />
            </>
        ),
    },
    'Transporter': {
        badgeBg: '#fbe9e7',
        stroke: '#d84315',
        paths: (
            <>
                <rect x="1" y="3" width="15" height="13" />
                <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
                <circle cx="5.5" cy="18.5" r="2.5" />
                <circle cx="18.5" cy="18.5" r="2.5" />
            </>
        ),
    },
    'Confirmed Qty': {
        badgeBg: '#e8f5e9',
        stroke: '#2e7d32',
        paths: (
            <>
                <polyline points="9 11 12 14 22 4" />
                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
            </>
        ),
    },
    'Confirmed Price': {
        badgeBg: '#e3f2fd',
        stroke: '#1565c0',
        paths: (
            <>
                <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
                <polyline points="9 11 12 14 22 4" />
            </>
        ),
    },
    'status': {
        badgeBg: '#e8f5e9',
        stroke: '#2e7d32',
        paths: (
            <>
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
            </>
        ),
    },
    'Grade': {
        badgeBg: '#fff8e1',
        stroke: '#f57f17',
        paths: (
            <>
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
            </>
        ),
    },
    'Lot No.': {
        badgeBg: '#e8eaf6',
        stroke: '#3f51b5',
        paths: (
            <>
                <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
                <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
                <line x1="8" y1="12" x2="16" y2="12" />
            </>
        ),
    },
    'Source': {
        badgeBg: '#e0f2f1',
        stroke: '#00796b',
        paths: (
            <>
                <path d="M12 22v-6" />
                <path d="M12 8V2" />
                <path d="M18 14H6c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v8c0 1.1-.9 2-2 2z" />
            </>
        ),
    },
    'Available': {
        badgeBg: '#e8f5e9',
        stroke: '#2e7d32',
        paths: (
            <>
                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
                <polyline points="9 11 12 14 22 4" />
            </>
        ),
    },
    'business': {
        badgeBg: '#e8f5e9',
        stroke: '#003B73',
        paths: (
            <>
                <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
                <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
            </>
        ),
    },
    'finance': {
        badgeBg: '#e3f2fd',
        stroke: '#1565c0',
        paths: (
            <>
                <line x1="12" y1="1" x2="12" y2="23" />
                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
            </>
        ),
    },
    'purchase': {
        badgeBg: '#fce4ec',
        stroke: '#c2185b',
        paths: (
            <>
                <circle cx="9" cy="21" r="1" />
                <circle cx="20" cy="21" r="1" />
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
            </>
        ),
    },
    'sales': {
        badgeBg: '#e8f5e9',
        stroke: '#2e7d32',
        paths: (
            <>
                <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
                <polyline points="17 6 23 6 23 12" />
            </>
        ),
    },
    'Logistics': {
        badgeBg: '#fff3e0',
        stroke: '#d84315',
        paths: (
            <>
                <rect x="1" y="3" width="15" height="13" />
                <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
                <circle cx="5.5" cy="18.5" r="2.5" />
                <circle cx="18.5" cy="18.5" r="2.5" />
            </>
        ),
    },
    'Reports': {
        badgeBg: '#f3e5f5',
        stroke: '#8e24aa',
        paths: (
            <>
                <line x1="18" y1="20" x2="18" y2="10" />
                <line x1="12" y1="20" x2="12" y2="4" />
                <line x1="6" y1="20" x2="6" y2="14" />
            </>
        ),
    },
    'quality': {
        badgeBg: '#e0f2f1',
        stroke: '#00796b',
        paths: (
            <>
                <circle cx="12" cy="12" r="10" />
                <circle cx="12" cy="12" r="6" />
                <circle cx="12" cy="12" r="2" />
            </>
        ),
    },
    'My trips': {
        badgeBg: '#fff3e0',
        stroke: '#ef6c00',
        paths: (
            <>
                <circle cx="12" cy="12" r="10" />
                <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
            </>
        ),
    },
    'Process Name': {
        badgeBg: '#e8eaf6',
        stroke: '#3f51b5',
        paths: (
            <>
                <circle cx="12" cy="12" r="3" />
                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
            </>
        ),
    },
    'Input Category': {
        badgeBg: '#e3f2fd',
        stroke: '#1565c0',
        paths: (
            <>
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="17 8 12 3 7 8" />
                <line x1="12" y1="3" x2="12" y2="15" />
            </>
        ),
    },
    'Output Category': {
        badgeBg: '#fce4ec',
        stroke: '#c2185b',
        paths: (
            <>
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
            </>
        ),
    },
    'Icon': {
        badgeBg: '#f3e5f5',
        stroke: '#8e24aa',
        paths: (
            <>
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                <circle cx="8.5" cy="8.5" r="1.5" />
                <polyline points="21 15 16 10 5 21" />
            </>
        ),
    },
    'Input': {
        badgeBg: '#e3f2fd',
        stroke: '#1565c0',
        paths: (
            <>
                <path d="M22 12H11" />
                <path d="m15 16-4-4 4-4" />
                <path d="M11 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h5" />
            </>
        ),
    },
    'Output': {
        badgeBg: '#e8f5e9',
        stroke: '#2e7d32',
        paths: (
            <>
                <path d="M13 12H2" />
                <path d="m9 16 4-4-4-4" />
                <path d="M13 4h5a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-5" />
            </>
        ),
    },
    'Quantity (KG)': {
        badgeBg: '#fff3e0',
        stroke: '#ef6c00',
        paths: (
            <>
                <line x1="12" y1="20" x2="12" y2="10" />
                <line x1="18" y1="20" x2="18" y2="4" />
                <line x1="6" y1="20" x2="6" y2="16" />
            </>
        ),
    },
    'Wastage': {
        badgeBg: '#fce4ec',
        stroke: '#c2185b',
        paths: (
            <>
                <polyline points="3 6 5 6 21 6" />
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                <line x1="10" y1="11" x2="10" y2="17" />
                <line x1="14" y1="11" x2="14" y2="17" />
            </>
        ),
    },
    'Team Size': {
        badgeBg: '#e0f7fa',
        stroke: '#006064',
        paths: (
            <>
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </>
        ),
    },
    'Working Hrs': {
        badgeBg: '#fff8e1',
        stroke: '#f57f17',
        paths: (
            <>
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
            </>
        ),
    },
    'Receipt': {
        badgeBg: '#f3e5f5',
        stroke: '#8e24aa',
        paths: (
            <>
                <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z" />
                <line x1="8" y1="9" x2="16" y2="9" />
                <line x1="8" y1="13" x2="16" y2="13" />
                <line x1="8" y1="17" x2="12" y2="17" />
            </>
        ),
    },
    'Due Date': {
        badgeBg: '#fbe9e7',
        stroke: '#d84315',
        paths: (
            <>
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
                <path d="M12 14h.01" />
                <path d="M12 17h.01" />
            </>
        ),
    },
    'Payment Info': {
        badgeBg: '#e8eaf6',
        stroke: '#3f51b5',
        paths: (
            <>
                <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
                <line x1="1" y1="10" x2="23" y2="10" />
                <path d="M12 15h.01" />
            </>
        ),
    },
    'Listing id': {
        badgeBg: '#e3f2fd',
        stroke: '#1565c0',
        paths: (
            <>
                <line x1="4" y1="9" x2="20" y2="9" />
                <line x1="4" y1="15" x2="20" y2="15" />
                <line x1="10" y1="3" x2="8" y2="21" />
                <line x1="16" y1="3" x2="14" y2="21" />
            </>
        ),
    },
    'QTY': {
        badgeBg: '#fff3e0',
        stroke: '#ef6c00',
        paths: (
            <>
                <line x1="8" y1="6" x2="21" y2="6" />
                <line x1="8" y1="12" x2="21" y2="12" />
                <line x1="8" y1="18" x2="21" y2="18" />
                <line x1="3" y1="6" x2="3.01" y2="6" />
                <line x1="3" y1="12" x2="3.01" y2="12" />
                <line x1="3" y1="18" x2="3.01" y2="18" />
            </>
        ),
    },
    'price': {
        badgeBg: '#e8f5e9',
        stroke: '#2e7d32',
        paths: (
            <>
                <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
                <line x1="7" y1="7" x2="7.01" y2="7" />
                <line x1="11" y1="11" x2="11.01" y2="11" />
            </>
        ),
    },
    'Verified By': {
        badgeBg: '#e0f2f1',
        stroke: '#00796b',
        paths: (
            <>
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
                <polyline points="16 11 18 13 22 9" />
            </>
        ),
    },
    'available': {
        badgeBg: '#e8f5e9',
        stroke: '#2e7d32',
        paths: (
            <>
                <polyline points="9 11 12 14 22 4" />
                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
            </>
        ),
    },
    'GRN INFO': {
        badgeBg: '#e0f7fa',
        stroke: '#006064',
        paths: (
            <>
                <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
                <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
                <path d="m9 14 2 2 4-4" />
            </>
        ),
    },
    'Requirement': {
        badgeBg: '#fff8e1',
        stroke: '#f57f17',
        paths: (
            <>
                <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
                <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
                <line x1="9" y1="12" x2="15" y2="12" />
                <line x1="9" y1="16" x2="13" y2="16" />
            </>
        ),
    },
    'Color': {
        badgeBg: '#f3e5f5',
        stroke: '#8e24aa',
        paths: (
            <>
                <circle cx="13.5" cy="6.5" r=".5" />
                <circle cx="17.5" cy="10.5" r=".5" />
                <circle cx="8.5" cy="7.5" r=".5" />
                <circle cx="6.5" cy="12.5" r=".5" />
                <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z" />
            </>
        ),
    },
    'Delivery Date': {
        badgeBg: '#fff3e0',
        stroke: '#e65100',
        paths: (
            <>
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
                <path d="M8 14h.01" />
                <path d="M12 14h.01" />
                <path d="M16 14h.01" />
            </>
        ),
    },
    'PO NUMBER': {
        badgeBg: '#e3f2fd',
        stroke: '#1565c0',
        paths: (
            <>
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="9" y1="13" x2="15" y2="13" />
                <line x1="9" y1="17" x2="15" y2="17" />
                <line x1="9" y1="9" x2="12" y2="9" />
            </>
        ),
    },
    'PO Qty': {
        badgeBg: '#e8f5e9',
        stroke: '#2e7d32',
        paths: (
            <>
                <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                <line x1="3" y1="6" x2="21" y2="6" />
                <path d="M16 10a4 4 0 0 1-8 0" />
            </>
        ),
    },
    'Bal Qty': {
        badgeBg: '#fff8e1',
        stroke: '#f57f17',
        paths: (
            <>
                <line x1="12" y1="3" x2="12" y2="21" />
                <path d="M6 8H3l3 6c0 1.657 1.343 3 3 3s3-1.343 3-3l3-6h-3" />
                <path d="M18 8h-3l3 6c0 1.657 1.343 3 3 3s3-1.343 3-3l-3-6h-3" />
                <line x1="3" y1="8" x2="21" y2="8" />
            </>
        ),
    },
    'due date': {
        badgeBg: '#fbe9e7',
        stroke: '#d84315',
        paths: (
            <>
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
                <path d="M12 14h.01" />
                <path d="M12 17h.01" />
            </>
        ),
    },
    'Listing': {
        badgeBg: '#e0f7fa',
        stroke: '#006064',
        paths: (
            <>
                <line x1="8" y1="6" x2="21" y2="6" />
                <line x1="8" y1="12" x2="21" y2="12" />
                <line x1="8" y1="18" x2="21" y2="18" />
                <line x1="3" y1="6" x2="3.01" y2="6" />
                <line x1="3" y1="12" x2="3.01" y2="12" />
                <line x1="3" y1="18" x2="3.01" y2="18" />
            </>
        ),
    },
    'Po number': {
        badgeBg: '#e3f2fd',
        stroke: '#1565c0',
        paths: (
            <>
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="9" y1="13" x2="15" y2="13" />
                <line x1="9" y1="17" x2="15" y2="17" />
                <line x1="9" y1="9" x2="12" y2="9" />
            </>
        ),
    },
    'qty': {
        badgeBg: '#fff3e0',
        stroke: '#ef6c00',
        paths: (
            <>
                <line x1="8" y1="6" x2="21" y2="6" />
                <line x1="8" y1="12" x2="21" y2="12" />
                <line x1="8" y1="18" x2="21" y2="18" />
                <line x1="3" y1="6" x2="3.01" y2="6" />
                <line x1="3" y1="12" x2="3.01" y2="12" />
                <line x1="3" y1="18" x2="3.01" y2="18" />
            </>
        ),
    },
    'payment': {
        badgeBg: '#e8f5e9',
        stroke: '#2e7d32',
        paths: (
            <>
                <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
                <line x1="1" y1="10" x2="23" y2="10" />
            </>
        ),
    },
    'material': {
        badgeBg: '#e8eaf6',
        stroke: '#3f51b5',
        paths: (
            <>
                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
                <line x1="12" y1="22.08" x2="12" y2="12" />
            </>
        ),
    },
    'color': {
        badgeBg: '#f3e5f5',
        stroke: '#8e24aa',
        paths: (
            <>
                <circle cx="13.5" cy="6.5" r=".5" />
                <circle cx="17.5" cy="10.5" r=".5" />
                <circle cx="8.5" cy="7.5" r=".5" />
                <circle cx="6.5" cy="12.5" r=".5" />
                <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z" />
            </>
        ),
    },
    'packaging': {
        badgeBg: '#e0f7fa',
        stroke: '#006064',
        paths: (
            <>
                <path d="M12 22V8" />
                <path d="m20 12-8-4-8 4" />
                <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                <path d="M15 22v-4a3 3 0 0 0-6 0v4" />
            </>
        ),
    },
    'balance': {
        badgeBg: '#fff8e1',
        stroke: '#f57f17',
        paths: (
            <>
                <line x1="12" y1="3" x2="12" y2="21" />
                <path d="M6 8H3l3 6c0 1.657 1.343 3 3 3s3-1.343 3-3l3-6h-3" />
                <path d="M18 8h-3l3 6c0 1.657 1.343 3 3 3s3-1.343 3-3l-3-6h-3" />
                <line x1="3" y1="8" x2="21" y2="8" />
            </>
        ),
    },
    'PR NO': {
        badgeBg: '#e3f2fd',
        stroke: '#1565c0',
        paths: (
            <>
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="9" y1="13" x2="15" y2="13" />
                <line x1="9" y1="17" x2="15" y2="17" />
                <line x1="9" y1="9" x2="12" y2="9" />
            </>
        ),
    },
    'items': {
        badgeBg: '#fce4ec',
        stroke: '#c62828',
        paths: (
            <>
                <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
                <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
            </>
        ),
    },
    'grade': {
        badgeBg: '#fff8e1',
        stroke: '#f57f17',
        paths: (
            <>
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
            </>
        ),
    },
}